import React from "react";

import { cn } from "../../../common/u1/cn";
import { CheckCircleIcon, LockIcon, ShieldIcon } from "../../../../assets/ui/icons";
import { TRUST_POINTS } from "./membershipFields";

const ICONS = {
  shield: ShieldIcon,
  lock: LockIcon,
  check: CheckCircleIcon,
};

/* The three reassurances under the benefits: refundable, Stripe, cancellable. */
export const TrustStrip = ({ className = "" }) => (
  <ul
    className={cn(
      "m-0 flex list-none flex-wrap items-center gap-x-5 gap-y-2 rounded-[12px]",
      "bg-[var(--field-inset)] px-4 py-3.5",
      className
    )}
  >
    {TRUST_POINTS.map((point) => {
      const Icon = ICONS[point.icon] || ShieldIcon;
      return (
        <li
          key={point.key}
          className="flex items-center gap-2 text-[12.5px] text-[var(--ink-2)] font-sans"
        >
          <span aria-hidden="true" className="text-[var(--success)]">
            <Icon size={14} />
          </span>
          {point.label}
        </li>
      );
    })}
  </ul>
);

export default TrustStrip;
